import { processEnv } from 'components/configuration/environmentVariables'
import L from 'leaflet'

export const API_ENDPOINT = processEnv.REACT_APP_AnalyticsAPIUri
export const PLACEHOLDER_MANUFACTURER = '-- Select Manufacturer --'
export const ALL_PRODUCT_TYPES = 'All Product Types'
export const ALL_PRODUCT_TYPES_STACKED = 'All Product Types (Stacked)'
export const MAP_TYPE_US_REGIONS = 'US Regions'
export const MAP_TYPE_DECISION_LOCATION = 'Decision Location'
export const DEFAULT_MAP_LOCATION = [37.8, -96] // Middle of continental US
export const DEFAULT_MAP_ZOOM_LEVEL = 4 // Fit continental US to map window
export const MAP_MAX_ZOOM = 14
export const MAP_ATTRIBUTION =
    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors. Pin icons made by <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons">Smashicons</a> from <a href="https://www.flaticon.com/"             title="Flaticon">www.flaticon.com</a>'
export const MAP_TILES_URL =
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
export const CHART_WIDTH = 750
export const CHART_HEIGHT = 300
export const DATA_LABEL_FONT_SIZE = 14
export const AXIS_LABEL_FONT_SIZE = 16
export const PIN_ICON_GOOD = new L.Icon({
    iconUrl: require('../images/pinIconGood.png'),
    iconRetinaUrl: require('../images/pinIconGood.png'),
    iconSize: [40, 40],
})
export const PIN_ICON_BAD = new L.Icon({
    iconUrl: require('../images/pinIconBad.png'),
    iconRetinaUrl: require('../images/pinIconBad.png'),
    iconSize: [40, 40],
})
export const PIN_ICON_MIXED = new L.Icon({
    iconUrl: require('../images/pinIconMixed.png'),
    iconRetinaUrl: require('../images/pinIconMixed.png'),
    iconSize: [40, 40],
})
export const COLOR_0 = 'white'
export const COLOR_1_OUT_OF_5 = '#edf8e9'
export const COLOR_2_OUT_OF_5 = '#bae4b3'
export const COLOR_3_OUT_OF_5 = '#74c476'
export const COLOR_4_OUT_OF_5 = '#31a354'
export const COLOR_5_OUT_OF_5 = '#006d2c'
